/**
 * The demo's frozen "now". One shared literal (no import.meta.env), so the
 * fixtures, the sim store and the ~365 clock readers all agree on a single
 * instant. Time no longer advances in the running app (see the persistence
 * fast-unlock design); the control panel fires events on demand against this
 * instant instead.
 *
 * 13:00 AEST on Mon 4 May 2026 is the same calendar day in Melbourne AND
 * Brisbane (see seed:verify's trading_day check), which is why it is the anchor.
 */
export const DEMO_NOW = '2026-05-04T13:00:00+10:00';
